export default () => ({
    branches: [],
    branchSelected:  JSON.parse(localStorage.getItem('branchSelected')) || null,
    askForLocation: !localStorage.getItem('branchSelected'),
    selectBranchModal: false,
});